<template>
  <div class="page">
    <nav-bar />
    <div class="page-wrapper">
      <div class="backgrounds">
        <div class="backgrounds__main">
          <div class="page-nav">
            <h2 class="page-nav__title">Шаг 3</h2>
            <a class="page-nav__link" @click="$router.go(-1)">Компоненты </a>
            <p class="page-nav__current">/ Фон страницы</p>
          </div>
          <h1 class="editor--title">Фон страницы</h1>
          <div class="backgrounds__current" v-if="!isMobile">
            <img
              class="backgrounds__current__image"
              :src="`${bigPreview}`"
              alt=""
            />
          </div>
          <div class="backgrounds__list" v-if="!isMobile">
            <label
              class="backgrounds__list__item"
              v-for="bg in bgs"
              :key="bg.id"
              :class="{
                'backgrounds__list__item--selected': isSelected(bg.id)
              }"
            >
              <input
                type="radio"
                v-model="selectedBg"
                :value="bg.id"
                name="selectedBg"
              />
              <img :src="`${bg.small_preview}`" alt="" />
              <div class="backgrounds__is_selected" v-show="isSelected(bg.id)">
                <div class="backgrounds__ok">
                  <div class="backgrounds__ok_icon">
                    <svg-icon type="checkmark" />
                  </div>
                </div>
              </div>
            </label>
          </div>
          <swiper :options="sliderOptions" ref="slider" v-if="isMobile">
            <swiper-slide v-for="bg in bgs" :key="bg.id">
              <label
                class="backgrounds__list__item"
                :class="{
                  'backgrounds__list__item--selected': isSelected(bg.id)
                }"
              >
                <input
                  type="radio"
                  v-model="selectedBg"
                  :value="bg.id"
                  name="selectedBg"
                />
                <img :src="`${bg.small_preview}`" alt="" />
                <div
                  class="backgrounds__is_selected"
                  v-show="isSelected(bg.id)"
                >
                  <div class="backgrounds__ok">
                    <div class="backgrounds__ok_icon">
                      <svg-icon type="checkmark" />
                    </div>
                  </div>
                </div>
              </label>
            </swiper-slide>
            <div class="backgrounds-pagination" slot="pagination"></div>
          </swiper>
        </div>
        <div class="backgrounds__buttons">
          <button
            class="pBtn--noborder pBtn"
            @click="
              () => {
                $router.go(-1);
                this.GAEvent('step_3-choose-wallpaper_back');
              }
            "
          >
            <svg-icon type="back" />
            Назад
          </button>
          <button class="pBtn--blue pBtn" @click="save">
            Сохранить
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import CCheckbox from "../../components/forms/CCheckbox";
import { mapGetters, mapState } from "vuex";

export default {
  name: "Background",
  components: { CCheckbox, swiper, swiperSlide },

  data() {
    return {
      isMobile: window.innerWidth < 768,
      selectedBg: this.$store.state.page.components.find(
        i => i.component_type.name === "Background"
      ).content.id,
      content: {},
      sliderOptions: {
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: -15,
        pagination: {
          el: ".backgrounds-pagination",
          clickable: true
        }
      }
    };
  },

  computed: {
    ...mapGetters(["getComponentByName"]),
    ...mapState({
      bgs: state => {
        return state.constructorData.selectedTemplate.backgrounds.map(bg => {
          if (!bg.small_preview.startsWith("/")) {
            bg.small_preview = `/${bg.small_preview}`;
          }
          return bg;
        });
      }
    }),
    bigPreview() {
      const found = this.bgs.find(item => item.id === this.selectedBg);
      if (found) {
        if (found.preview.startsWith("/")) {
          return found.preview;
        } else {
          return `/${found.preview}`;
        }
      }
      return null;
    }
  },

  methods: {
    save() {
      const saveToVuexAndServer = () => {
        return this.$store.dispatch("syncComponent", {
          id: this.getComponentByName("Background").id,
          content: this.content
        });
      };
      saveToVuexAndServer();
      this.GAEvent(
        "step_3-choose-wallpaper",
        "chosen-wallpaper",
        this.content.note
      );
    },
    fillFromState() {
      if (this.getComponentByName("Background")) {
        this.content = Object.assign(
          {},
          this.getComponentByName("Background").content
        );
      }
    },
    isSelected(id) {
      return this.selectedBg === id;
    }
  },
  mounted() {
    this.fillFromState();
  },
  watch: {
    selectedBg(bg) {
      this.content = this.bgs.find(item => item.id === bg);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/vars";

.page {
  background: #3479cc;
  @media #{$tablet} {
    padding-bottom: 0;
  }

  &-wrapper {
    max-width: 100%;
    display: flex;
    justify-content: center;
    @media #{$tablet} {
      margin: 0;
      padding: 0;
    }
  }
}

.backgrounds {
  width: 100%;
  max-width: 1200px;
  background: #f4f4f4;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  @media #{$tablet} {
    min-height: calc(100vh - 75px);
    border-radius: 0;
    justify-content: space-between;
  }
  @media #{$mobile} {
    background: #ffffff;
    padding: 0 15px;
    justify-content: flex-start;
  }

  * {
    font-family: "Inter", sans-serif;
  }

  &__title {
    font-size: 48px;
    font-weight: bold;
    text-align: left;
    margin: 0 0 60px;
    padding: 0;
    @media #{$mobile} {
      font-size: 34px;
      margin: 0 0 30px;
      padding: 0 15px;
    }
  }

  &__main {
    padding: 60px 70px;
    @media #{$tablet} {
      padding: 30px;
    }
    @media #{$mobile} {
      padding: 30px 0;
    }
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
  }

  &__item {
    width: calc(100% / 3);
    margin-bottom: 45px;

    @media #{$tablet} {
      width: calc(100% / 2);
    }

    @media #{$mobile} {
      width: 100%;
      margin-bottom: 5px;
    }
  }

  &__buttons {
    background: #ffffff;
    padding: 30px 70px;
    display: flex;
    justify-content: space-between;
    @media #{$mobile} {
      flex-direction: column-reverse;
      padding: 0 15px;
    }
  }

  &__current {
    width: 100%;
    border-radius: 12px;
    margin-bottom: 20px;
    overflow: hidden;
    height: 230px;
    display: flex;
    justify-content: center;
    @media #{$mobile} {
      height: 160px;
    }
    &__image {
      object-fit: cover;
      height: auto;
      width: auto;
      min-width: 100%;
      min-height: 100%;
    }
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    &__item {
      flex-basis: calc(100% / 3 - 15px);
      margin-bottom: 15px;
      border-radius: 12px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      position: relative;
      cursor: pointer;
      height: 130px;
      input {
        display: none;
      }
      @media #{$tablet} {
        flex-basis: calc(50% - 15px);
      }
      @media #{$mobile} {
        flex-basis: 100%;
        height: 160px;
      }
      &--selected {
        pointer-events: none;
      }
      img {
        object-fit: cover;
        min-width: 100%;
        min-height: 100%;
        width: auto;
        height: auto;
      }
    }
  }
  &__ok {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    &_icon {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #26cc72;
      width: 72px;
      height: 72px;
      border-radius: 100%;
    }
  }
  .swiper-slide {
    transition: all 0.3s ease;
  }
  .swiper-slide-next,
  .swiper-slide-prev {
    transform: scale(0.8);
  }
  .swiper-container {
    overflow: visible;
  }
  .backgrounds-pagination {
    text-align: center;
    margin-bottom: 60px;
  }
  /deep/ .swiper-pagination-bullet {
    width: 9px;
    height: 9px;
    opacity: 1;
    margin: 0 5px !important;
    background: #c4c4c4;
    &-active {
      background: #000000;
    }
  }
}
</style>
